// 练习相关的API函数

import { localApi } from '../utils/axios';

// 获取练习列表
export const getExercises = async (params = {}) => {
  try {
    const response = await localApi.get('/exercises', { params });
    return response.data.data || [];
  } catch (error) {
    console.error('获取练习列表失败:', error);
    throw error;
  }
};

// 创建练习
export const createExercise = async (exerciseData) => {
  try {
    const response = await localApi.post('/exercises', exerciseData);
    return response.data.data;
  } catch (error) {
    console.error('创建练习失败:', error);
    throw error;
  }
};

// 获取练习详情
export const getExerciseById = async (id) => {
  try {
    const response = await localApi.get(`/exercises/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('获取练习详情失败:', error);
    throw error;
  }
};

// 更新练习
export const updateExercise = async (id, exerciseData) => {
  try {
    const response = await localApi.put(`/exercises/${id}`, exerciseData);
    return response.data.data;
  } catch (error) {
    console.error('更新练习失败:', error);
    throw error;
  }
};

// 删除练习
export const deleteExercise = async (id) => {
  try {
    const response = await localApi.delete(`/exercises/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('删除练习失败:', error);
    throw error;
  }
};

// 切换练习活动状态
export const toggleExerciseActive = async (id) => {
  try {
    const response = await localApi.patch(`/exercises/${id}/toggle-active`);
    return response.data.data;
  } catch (error) {
    console.error('切换练习状态失败:', error);
    throw error;
  }
};

// 批量删除练习
export const batchDeleteExercises = async (ids) => {
  try {
    const response = await localApi.delete('/exercises/batch', { data: { ids } });
    return response.data.data;
  } catch (error) {
    console.error('批量删除练习失败:', error);
    throw error;
  }
};

// 分配练习给学生
export const assignExercise = async (exerciseId, assignmentData) => {
  try {
    const response = await localApi.post(`/exercises/${exerciseId}/assign`, assignmentData);
    return response.data.data;
  } catch (error) {
    console.error('分配练习失败:', error);
    throw error;
  }
};

// 获取分配历史
export const getAssignments = async (params = {}) => {
  try {
    const response = await localApi.get('/assignments', { params });
    return response.data.data || [];
  } catch (error) {
    console.error('获取分配历史失败:', error);
    throw error;
  }
};

// 获取分配详情
export const getAssignmentDetails = async (id) => {
  try {
    const response = await localApi.get(`/assignments/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('获取分配详情失败:', error);
    throw error;
  }
};

// 获取分类列表
export const getCategories = async () => {
  try {
    const response = await localApi.get('/categories');
    return response.data.data.categories || [];
  } catch (error) {
    console.error('获取分类列表失败:', error);
    throw error;
  }
};

// 获取教师统计数据
export const getTeacherStats = async () => {
  try {
    const response = await localApi.get('/teacher/stats');
    return response.data.data;
  } catch (error) {
    console.error('获取教师统计数据失败:', error);
    throw error;
  }
};

// 获取练习完成情况
export const getExerciseStats = async (id) => {
  try {
    const response = await localApi.get(`/teacher/exercises/${id}/stats`);
    return response.data.data;
  } catch (error) {
    console.error('获取练习统计数据失败:', error);
    throw error;
  }
};

// 学生端 - 获取分配给学生的练习列表
export const getStudentExercises = async (params = {}) => {
  try {
    const response = await localApi.get('/student/exercises', { params });
    return response.data.data || [];
  } catch (error) {
    console.error('获取学生练习列表失败:', error);
    throw error;
  }
};

// 学生端 - 获取练习详情（做题）
export const getStudentExerciseDetail = async (assignmentId) => {
  try {
    const response = await localApi.get(`/student/exercises/${assignmentId}`);
    return response.data.data;
  } catch (error) {
    console.error('获取学生练习详情失败:', error);
    throw error;
  }
};

// 学生端 - 提交答案
export const submitAnswer = async (submissionData) => {
  try {
    const response = await localApi.post('/student/submissions', submissionData);
    return response.data.data;
  } catch (error) {
    console.error('提交答案失败:', error);
    throw error;
  }
};

// 学生端 - 完成练习
export const completeExercise = async (exerciseId, submissionData) => {
  try {
    const response = await localApi.post(`/student/exercises/${exerciseId}/complete`, submissionData);
    return response.data.data;
  } catch (error) {
    console.error('完成练习失败:', error);
    throw error;
  }
};  
